import $ from 'jquery';

$(function () {
  let scrollPos;
  const body = $('body');
  const hamburger = $('.js-hamburger');
  const drawer = $('.js-drawer');
  const closeButton = $('.js-drawerClose');
  const menuBar = $('.js-menubar');

  hamburger.on('click', function () {
    scrollPos = $(window).scrollTop();
    $(this).attr('aria-expanded', 'true');
    drawer.show().attr('aria-hidden', 'false');
    body.addClass('is-fixed').css({ top: -scrollPos });
    menuBar.addClass('is-drawer-open');
    $('.l-header').css('position', 'fixed');
  });

  /*
   * クローズボタンクリック
   */
  closeButton.on('click', function () {
    closeDrawer();
  });

  $(document).on('click', function (e) {
    if (body.hasClass('is-fixed') && !$(e.target).closest('.js-hamburger').length) {
      if (!$(e.target).closest('.p-header__menu').length) {
        closeDrawer();
      }
    }
  });

  const closeDrawer = () => {
    hamburger.attr('aria-expanded', 'false');
    drawer.hide().attr('aria-hidden', 'true');
    body.removeClass('is-fixed').css('top', '');
    menuBar.removeClass('is-drawer-open');
    $('html, body').scrollTop(scrollPos);
    $('.l-header').css('position', 'sticky');
    $('.js-accordionContents').removeAttr('style');
    $('.js-accordionTerm').removeClass('is-open');
  };
});
